module.exports = __webpack_public_path__ + "static/media/sun.d8b06074.svg";